import { render, staticRenderFns } from "./CompleteParcelsAtStopModal.vue?vue&type=template&id=13f85c3b&scoped=true"
import script from "./CompleteParcelsAtStopModal.vue?vue&type=script&lang=js"
export * from "./CompleteParcelsAtStopModal.vue?vue&type=script&lang=js"
import style0 from "./CompleteParcelsAtStopModal.vue?vue&type=style&index=0&id=13f85c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f85c3b",
  null
  
)

export default component.exports